module.exports = __webpack_public_path__ + "img/cart--white.740e5139.svg";